import { RootState } from 'editor/src/store/index';

import { ColorSpace } from '../types';

const getDesignColorSpace = (state: RootState) =>
  state.hostSettings.cmykOnly ? ColorSpace.CMYK : state.design.designData?.color_space ?? ColorSpace.sRGB;

export default getDesignColorSpace;
